/**
 * Логгер клиента: пишет в консоль только в dev-сборке. В production
 * вызовы ничего не делают — сбои побочных сервисов (звук, аналитика) не
 * должны засорять консоль пользователя.
 */

type LogArgs = readonly unknown[];

const enabled = import.meta.env.DEV;

export const logger = {
  debug: (...args: LogArgs): void => {
    // Отладка идёт через warn: правило линтера оставляет в коде только
    // warn/error, а в production логгер всё равно молчит.
    if (enabled) console.warn('[debug]', ...args);
  },
  warn: (...args: LogArgs): void => {
    if (enabled) console.warn(...args);
  },
} as const;
